import Checkbox from '../../../shared/components/Checkbox'

const MultiAccessCheckbox = ({ companyUser }) => (
  <div className="form-group">
    <Checkbox name="is_agency_user" label="Grant multi-company access" isChecked={ companyUser && companyUser.is_agency_user } />
  </div>
)
export default MultiAccessCheckbox



// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/company-users/components/forms/MultiAccessCheckbox.js